// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_25ssa","closeIcon":"_2AqJS","header":"_3xXh4","content":"BrPyz"};